// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as TicketVm from "../../vm-mapper/TicketVm.bs.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as RecordsWrapper from "../../../../order-dashboard/view/components/non-live-order-dashboard/components/RecordsWrapper.bs.js";
import * as WorkSpaceContext from "../../../../../../library/work-space/WorkSpaceContext.bs.js";
import * as CardTitleWithImage from "../../../../order-dashboard/view/components/non-live-order-dashboard/components/CardTitleWithImage.bs.js";
import * as PrimaryCard$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/primary-card/PrimaryCard.bs.js";
import * as TertiaryButton$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/TertiaryButton.bs.js";
import * as CardRowViewMapper$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardRowViewMapper.bs.js";
import * as TicketDashboardAssetsManager from "../../assets/TicketDashboardAssetsManager.bs.js";

var order_icon = TicketDashboardAssetsManager.getImage("order.svg");

function getViewLabel(ticket_order, workspace_dispatch) {
  return {
          hd: {
            label: "CRN",
            value: {
              TAG: /* Custom */1,
              _0: (function (param) {
                  var crn = ticket_order.crn;
                  if (crn !== undefined) {
                    return React.createElement(TertiaryButton$Catalyst.make, {
                                onSelectCB: (function (param) {
                                    return Curry._2(workspace_dispatch.addTab, {
                                                TAG: /* OrderDetails */10,
                                                _0: crn,
                                                _1: undefined
                                              }, false);
                                  }),
                                children: crn
                              });
                  } else {
                    return "--";
                  }
                })
            }
          },
          tl: {
            hd: {
              label: "MSISDN",
              value: {
                TAG: /* Text */0,
                _0: Belt_Option.getWithDefault(ticket_order.msisdn, "--")
              }
            },
            tl: {
              hd: {
                label: "Phone no.",
                value: {
                  TAG: /* Text */0,
                  _0: ticket_order.mobile
                }
              },
              tl: {
                hd: {
                  label: "Geo Region",
                  value: {
                    TAG: /* Text */0,
                    _0: ticket_order.geo_region
                  }
                },
                tl: /* [] */0
              }
            }
          }
        };
}

function TicketOrderDetails(Props) {
  var ticket = Props.ticket;
  var match = TicketVm.getVm(ticket);
  var workspaceDispatch = WorkSpaceContext.useWorkSpace(undefined);
  return React.createElement(PrimaryCard$Catalyst.make, {
              title: {
                TAG: /* Custom */1,
                _0: (function (param) {
                    return React.createElement(CardTitleWithImage.make, {
                                title: "Order Details",
                                icon_src: order_icon
                              });
                  })
              },
              action: undefined,
              className: "primary-info-card",
              children: React.createElement(RecordsWrapper.make, {
                    children: CardRowViewMapper$Catalyst.CardRecordView.make("record", getViewLabel(match.order, workspaceDispatch))
                  })
            });
}

var make = TicketOrderDetails;

export {
  order_icon ,
  getViewLabel ,
  make ,
  
}
/* order_icon Not a pure module */
